import translations from './lang/i18n.json'
import { parseTranslations } from './lang/parseTranslations'

const messages = parseTranslations(JSON.stringify(translations))

export default defineI18nConfig(() => ({
  legacy: false,
  messages: messages,
}))
